import { createBrowserRouter } from 'react-router-dom'

import { RootLayout } from '@/components/layout'
import { ROUTES } from '@/config/site'
import { AboutPage } from '@/pages/AboutPage'
import { CahayaPage } from '@/pages/CahayaPage'
import { ExpeditionPage } from '@/pages/ExpeditionPage'
import { HomePage } from '@/pages/HomePage'
import { JoinPage } from '@/pages/JoinPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { SciencePage } from '@/pages/SciencePage'

export const router = createBrowserRouter([
  {
    path: ROUTES.home,
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: ROUTES.cahaya, element: <CahayaPage /> },
      { path: ROUTES.expedition, element: <ExpeditionPage /> },
      { path: ROUTES.science, element: <SciencePage /> },
      { path: ROUTES.about, element: <AboutPage /> },
      { path: ROUTES.join, element: <JoinPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
